import React from 'react';
import AllRoute from '../router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BookNowProvider } from '../../context/BookNowContext';

const App = () => {
  return (
    <div className="App" id="scrool">
      <BookNowProvider>
        <AllRoute />
        <ToastContainer />
      </BookNowProvider>
    </div>
  );
};

export default App;